import { get, groupBy, map } from 'lodash';
import React, { Component, PropTypes } from 'react';
import cx from 'classnames';
import Divider from 'material-ui/Divider';
import MenuItem from './c_SourceModMenuItem';
import DropDownMenu from './c_SourceModDropDown';
import CloseX from './../svgs/CloseX/index';

const groupNameStyle = {
  fontSize    : '16px',
  fontWeight  : '500',
  overflow    : 'hidden',
  padding     : '8px',
  textOverflow: 'ellipsis',
  whiteSpace  : 'nowrap',
};

function MenuItemGroup(props) {

  const renderGroupName = (groupName) =>
    groupName && groupName !== 'undefined' && (<div className='floatingLabelText' style={groupNameStyle}>{props.groupName}</div>)
  ;

  const onChange = (item, index) =>
    (event) => props.onChange && props.onChange(event, item, index)
  ;

  const byName = (item1, item2) =>
    item1.name.localeCompare(item2.name)
  ;

  return (
    <div>
      <Divider className='Divider' />
      {
        renderGroupName(props.groupName)
      }
      {
        props.menuItems
          .sort(byName)
          .filter(item => item.hasOwnProperty('hide') ? !item.hide : true)
          .map((item, index) =>
          (
            <MenuItem
              checkBox
              checked={props.selectedItems.includes(item.value || item.id)}
              value={item.value || item.id}
              primaryText={item.primaryText || item.name}
              key={index}
              data-id={item.primaryText || item.name}
              onTouchTap={onChange(item, index)}
            />
          )
        )
      }
    </div>
  );
}

MenuItemGroup.propTypes = {
  menuItems : PropTypes.array.isRequired,
  selectedItems : PropTypes.array.isRequired,
  groupName : PropTypes.string,
  onChange  : PropTypes.func
};


function MenuItemGroups(props) {
  const groups = groupBy(props.menuItems, props.groupBy);

  return (
    <div>
      {
        map(groups, (group, key) =>
          (
            <MenuItemGroup
              menuItems={group}
              selectedItems={props.selectedItems}
              groupName={key}
              onChange={props.onChange}
            />
          )
        )
      }
    </div>
  );
}

MenuItemGroups.propTypes = {
  menuItems     : PropTypes.array.isRequired,
  selectedItems : PropTypes.array.isRequired,
  groupBy       : PropTypes.string,
  onChange      : PropTypes.func
};


function Tags(props) {
  const tags = props.selectedItems.map(item =>
      props.menuItems.find(i => (i.value || i.id) === item)
    )
    .filter(item => !!item)
  ;

  const value = (tag) => (tag.value || tag.id);
  const name = (tag) => (tag.primaryText || tag.name);
  const removeItem = (tag) => (event) => props.onRemove && props.onRemove(event, tag);

  return (
    <div className='checked-tags-container'>
      <Divider className='Divider' />
      {
        tags.map((tag, index) =>
          <div className='checked-tag-container' key={index}>
            <div className='checked-tag'>
              {name(tag)}
              <CloseX
                className='checked-tag-item'
                data-id={`${value(tag)} Tag`}
                onClick={removeItem(tag)}
                style={
                  {
                    strokeWidth: 1,
                    color: '#4a4a4a',
                    marginLeft: '5px',
                    width: '10px',
                    height: '10px'
                  }
                }
              />
            </div>
          </div>
        )
      }
    </div>
  );

}

Tags.propTypes = {
  menuItems     : PropTypes.array.isRequired,
  selectedItems : PropTypes.array,
  onRemove    : PropTypes.func
};

const labelStyle = {
  color: '#4a4a4a',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: '16px',
  height: '48px'
};

const commonWidth = '384px';

const listStyle = {
  backgroundColor: '#fafafa',
  fontWeight: 100,
  maxWidth: commonWidth
};

const menuStyle = {
  backgroundColor: '#fafafa',
  overflowY: 'auto',
  overflowX: 'hidden',
  maxWidth: commonWidth
};

export default class DropdownChecklist extends Component {
  static propTypes = {
    menuItems   : PropTypes.array.isRequired,
    defaultValue: PropTypes.any,
    value       : PropTypes.any,
    onChange    : PropTypes.func,
    onBlur      : PropTypes.func,
    textLabel   : PropTypes.string,
    defaultLabel: PropTypes.string,
    groupBy     : PropTypes.string,
    className   : PropTypes.string,
    errorText   : PropTypes.string,
    'data-id'   : PropTypes.string,
    disabled    : PropTypes.bool,
    required    : PropTypes.bool,
    dirty       : PropTypes.bool,
  }

  static defaultProps = {
    defaultLabel : 'Select'
  }

  constructor(props) {
    super(props);

    this.state = {
      selectedItems: props.value || []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'menuItems.length') !== get(this.props, 'menuItems.length') || !nextProps.value) {
      const newState = this.newState();
      newState.selectedItems = nextProps.value || []; // WPS-43 - do not clear segment types when parent changes
      this.setState(newState);
      this.onChange(null, newState.selectedItems);
    }
  }

  onChange = (event, newValue) => {
    if (this.props.onChange) {
      this.props.onChange(event, newValue);
    }
  }

  onBlur = (event) => {
    if (this.props.onBlur) {
      this.props.onBlur(event, this.state.selectedItems);
    }
  }

  onToggle = (event, item) => {
    const newState = this.newState();
    const { selectedItems } = newState;
    if (selectedItems.includes(item.id)) {
      // WPS-43 - user may not remove all items from list, one must remain.
      if (selectedItems.length > 1) {
        newState.selectedItems = selectedItems.filter(i => i !== item.id);
      }
    }
    else {
      newState.selectedItems.push(item.id);
    }

    this.setState(newState);
    return this.onChange(event, newState.selectedItems);
  }

  newState() {
    return Object.assign({}, this.state);
  }

  isError() {
    return (this.props.required && this.props.dirty && !this.state.selectedItems.length);
  }

  render() {

    const selectedText = () =>
      this.props.menuItems
        .filter(item => this.state.selectedItems.includes(item.id))
        .map(item => get(item, 'name'))
        .join(', ') || this.props.defaultLabel
    ;

    const containerStyle = cx('clearfix', 'dropdown-wrapper checklist-wrapper', {disabled: this.props.disabled, optional: !this.props.required, error: this.isError()});

    return (
      <div className={containerStyle}>
        <div
          className={cx('floatingLabelText')}
          data-id={`${this.props['data-id']} floatingLabelText`}
          style={this.isError() ? {color: 'rgb(244, 67, 54)'} : null}
        >
          {this.props.textLabel}
        </div>
        <DropDownMenu
          className={cx('dropdown', {disabled: this.props.disabled})}
          labelStyle={labelStyle}
          listStyle={listStyle}
          menuStyle={menuStyle}
          popoverStyle={{width: commonWidth}}
          autoWidth={false}
          canAutoPosition
          checkList
          data-id={this.props['data-id']}
        >
          <MenuItem
            primaryText={selectedText()}
            className={'checklist-header dropdown-label'}
            value={null}
          />
          <Tags
            menuItems={this.props.menuItems}
            selectedItems={this.state.selectedItems}
            onRemove={this.onToggle}
          />
          <MenuItemGroups
            menuItems={this.props.menuItems}
            selectedItems={this.state.selectedItems}
            groupBy={this.props.groupBy}
            onChange={this.onToggle}
          />
        </DropDownMenu>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./shared/common/components/DropdownChecklist.js